import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "8054fUijO5CrrTcRKm9XeMc", "MathBase", undefined);

import { error, Rect, v2, UITransform, v3, Vec2, misc } from "cc";
import { E_TimeShowType } from "../EnumBase";

var MathBase = /*#__PURE__*/function () {
  function MathBase() {
    _defineProperty(this, "_arrayHandler", new ArrayHandler());

    _defineProperty(this, "_numHandler", new NumHandler());

    _defineProperty(this, "_posHandler", new PosHandler());
  }

  _createClass(MathBase, [{
    key: "arrayHandler",
    get: function get() {
      return this._arrayHandler;
    }
    /**number处理器 */

  }, {
    key: "numHandler",
    get: function get() {
      return this._numHandler;
    }
    /**坐标处理器 */

  }, {
    key: "PosHandler",
    get: function get() {
      return this._posHandler;
    }
  }], [{
    key: "I",
    get: function get() {
      if (!MathBase._I) {
        MathBase._I = new MathBase();
      }

      return MathBase._I;
    }
    /**数组处理器 */

  }]);

  return MathBase;
}();
/**
 * ***************************** 数组处理
 */


_defineProperty(MathBase, "_I", null);

export { MathBase as default };
export var ArrayHandler = /*#__PURE__*/function () {
  function ArrayHandler() {}

  var _proto = ArrayHandler.prototype;

  /**创建 数组， 长度为 len, 从0开始 */
  _proto.create_int = function create_int(len, deltaN) {
    if (deltaN === void 0) {
      deltaN = 0;
    }

    return Array.from({
      length: len
    }, function (v, k) {
      return k + deltaN;
    });
  }
  /**删除某一个元素 */
  ;

  _proto.splice_int = function splice_int(arr, v) {
    var index = arr.indexOf(v);

    if (index != -1) {
      arr.splice(index, 1);
      return arr;
    } else {
      error("not find " + v + " in array");
      return arr;
    }
  };

  _proto.splice_str = function splice_str(arr, v) {
    var index = arr.indexOf(v);

    if (index != -1) {
      return arr.splice(index, 1);
    } else {
      error("not find " + v + " in array");
      return arr;
    }
  }
  /**
   * 去除A数组中包含B的元素
   * @param arrA 需要过滤的数组
   * @param arrB 过滤的元素
   */
  ;

  _proto.filter = function filter(arrA, arrB) {
    arrA = arrA.filter(function (e) {
      return arrB.indexOf(e) < 0;
    });
    return arrA;
  };

  return ArrayHandler;
}();
/**
 * ************************************** 数字处理
 */

export var NumHandler = /*#__PURE__*/function () {
  function NumHandler() {
    _defineProperty(this, "minIndex", 1);
  }

  var _proto2 = NumHandler.prototype;

  /**整数随机 */
  _proto2.round_int = function round_int(num, deltaNum) {
    if (deltaNum === void 0) {
      deltaNum = 0;
    }

    if (num == 0) return deltaNum;
    return Math.floor(Math.random() * num) + deltaNum;
  };

  _proto2.round_singedInt = function round_singedInt(num) {
    if (num == 0) return 0;
    return Math.floor(Math.random() * num) - Math.floor(Math.random() * num);
  }
  /**整数随机 */
  ;

  _proto2.round_float = function round_float(num, deltaNum) {
    if (deltaNum === void 0) {
      deltaNum = 0;
    }

    if (num == 0) return deltaNum;
    return Math.random() * num + deltaNum;
  };

  _proto2.round_singedFloat = function round_singedFloat(num) {
    if (num == 0) return 0;
    return Math.random() * num - Math.random() * num;
  }
  /**正态分布 */
  ;

  _proto2.gaussian = function gaussian() {
    var y1 = 0;
    var x1 = 0;
    var x2 = 0;
    var w = 0;

    do {
      x1 = Math.random() * 2 - 1;
      x2 = Math.random() * 2 - 1;
      w = x1 * x1 + x2 * x2;
    } while (w >= 1);

    w = Math.sqrt(-2 * Math.log(w) / w);
    y1 = x1 * w;
    return y1;
  };

  /**随机 rect 上的某一点 */
  _proto2.round_inRect = function round_inRect(rect) {
    if (rect) {
      var r_x = this.round_float(rect.width);
      var r_y = this.round_float(rect.height);
      return v2(rect.x + r_x, rect.y + r_y);
    } else {
      error("rect is unddefined");
    }
  }
  /**最小值得 幂次方 */
  ;

  _proto2.checkGrowthRange = function checkGrowthRange(v) {
    if (v <= Math.pow(2, 10)) {
      this.minIndex = 1;
    } else {
      this.minIndex = this.get_order(v) - 10;
    }
  }
  /**返回2的次方数 */
  ;

  _proto2.get_order = function get_order(v) {
    var order = -1;
    v = v - 1 >> 0;

    while (v) {
      v >> 1;
      order++;
    }

    return order;
  }
  /**
   * 转化单位（过万以万为单位， 过亿以亿为单位）
   * @param num 需要转换的数字
   */
  ;

  _proto2.switchUnit = function switchUnit(num) {
    // let numStr = ["万", "亿", "万亿"];
    var numStr = ["k", "m", "b"]; //["千", "百万", "十亿"]

    var totalNum = 0;
    var tempNum = num;

    while (tempNum > 1000) {
      totalNum++;
      tempNum = tempNum / 1000;
    } // let leftNum: number = 0;


    var leftNum = num;

    while (leftNum >= 1000) {
      leftNum %= 1000;
    }

    var strU = "";

    if (totalNum > 0) {
      strU = numStr[totalNum - 1];
      return Math.floor(tempNum) + (leftNum / 100 > 1 ? "." + Math.floor(leftNum / 100) : "") + strU;
    } else {
      return num + "";
    }
  } //转化时间： h:m:s
  ;

  _proto2.switchTime = function switchTime(num, type) {
    num = Math.floor(num);
    var hour = Math.floor(num / 60 / 60);
    var minute = Math.floor((num - hour * 60 * 60) / 60);
    var seconds = num % 60;

    switch (type) {
      case E_TimeShowType.HMS:
        return " " + this.addZeroPre(hour, 2) + " : " + this.addZeroPre(minute, 2) + " : " + this.addZeroPre(seconds, 2) + " ";

      case E_TimeShowType.MS:
        if (hour > 0) {
          return hour * 60 + minute + " : " + this.addZeroPre(seconds, 2) + " ";
        } else {
          return this.addZeroPre(minute, 2) + " : " + this.addZeroPre(seconds, 2) + " ";
        }

    }
  }
  /**
   * 保留指定长度的显示，不足前面补零
   * @param num 数值
   * @param len 保留长度
   */
  ;

  _proto2.addZeroPre = function addZeroPre(num, len) {
    return (Array(len).join('0') + num).slice(-len);
  };

  return NumHandler;
}();
/**
 * ***********************************字符串处理
 */

export var StringHandler = /*#__PURE__*/function () {
  function StringHandler() {}

  var _proto3 = StringHandler.prototype;

  /**
   * 获取裁剪后的字符长度
   * @param str 目标字符串
   * @param len 裁剪长度
   */
  _proto3.cutStr = function cutStr(str, len) {
    if (len === void 0) {
      len = 6;
    }

    var tNum = 0;
    var aimStr = "";

    for (var i = 0; i < str.length; ++i) {
      var curChar = str.charCodeAt(i);

      if (curChar > 0 && curChar <= 128) {
        tNum += 1;
      } else {
        tNum += 2;
      }

      if (tNum >= len) {
        aimStr += str.charAt(i);

        if (i < str.length - 1) {
          tNum++;
          aimStr += "...";
        }

        break;
      } else {
        aimStr += str.charAt(i);
      }
    }

    if (tNum <= len) {
      return str;
    }

    return aimStr;
  };

  return StringHandler;
}();
/**
 * **************************************坐标处理
 */

export var PosHandler = /*#__PURE__*/function () {
  function PosHandler() {}

  var _proto4 = PosHandler.prototype;

  /**
   * 转为为世界坐标
   * @param aimNode 转换节点
   */
  _proto4.toW = function toW(aimNode) {
    return aimNode.getComponent(UITransform).convertToWorldSpaceAR(v3(0, 0));
  }
  /**
   * 转换为局部坐标
   * @param aimNode 转换节点
   */
  ;

  _proto4.toN = function toN(aimNode) {
    return aimNode.getComponent(UITransform).convertToNodeSpaceAR(v3(0, 0));
  }
  /**
   * 获取屏幕点的世界坐标
   * @param camera 摄像机
   * @param pos 屏幕坐标
   */
  ;

  _proto4.SToW = function SToW(camera, pos) {
    var out = v3();
    camera.screenToWorld(pos, out);
    return out;
  }
  /**
   * 获取节点的边界值（本地）
   * @param aimN 节点
   * @param dir 节点的边界 GEnum.NodeBorder
   */
  ;

  _proto4.border_local = function border_local(aimN, dir) {
    var pos = v3(aimN.position);
    var size = aimN.getComponent(UITransform).contentSize;
    var v = 0;

    switch (dir) {
      case "top":
        v = pos.y + size.height / 2;
        break;

      case "bottom":
        v = pos.y - size.height / 2;
        break;

      case "left":
        v = pos.x - size.width / 2;
        break;

      case "right":
        v = pos.x + size.width / 2;
        break;
    }

    return v;
  }
  /**
   * 获取节点的边界值（世界）
   * @param aimN 节点
   * @param dir 节点的边界 GEnum.NodeBorder
   */
  ;

  _proto4.border_W = function border_W(aimN, dir) {
    var pos = this.toW(aimN);
    var size = aimN.getComponent(UITransform).contentSize;
    var v = 0;

    switch (dir) {
      case "top":
        v = pos.y + size.height / 2;
        break;

      case "bottom":
        v = pos.y - size.height / 2;
        break;

      case "left":
        v = pos.x - size.width / 2;
        break;

      case "right":
        v = pos.x + size.width / 2;
        break;
    }

    return v;
  }
  /**距离 */
  ;

  _proto4.dis = function dis(n1, n2) {
    return v3(n1.position).subtract(v3(n2.position)).length();
  }
  /**距离 */
  ;

  _proto4.dis_vec = function dis_vec(v1, v2) {
    return v1.subtract(v2).length();
  }
  /**是否相等
   * offLen: 容差
   */
  ;

  _proto4.equal = function equal(v1, v2, offLen) {
    var len = v1.subtract(v2).length();
    return len < offLen ? true : false;
  }
  /**
   * 使用二次 贝塞尔曲线 光滑坐标集合
   * @param pos_game 坐标集合
   * @param step 两点之间的最小 单位
   * @returns 填充后的数组
   */
  ;

  _proto4.bezierPos = function bezierPos(pos_game, step) {
    if (pos_game.length < 3) return;
    var p0 = v3();
    var p1 = v3();
    var p2 = v3(); //根据角度差，判定是否添加新的点， 根据线段长度，确定新增加点的个数

    var pos_offset01 = v2();
    var pos_offset12 = v2();
    var pos_offset02 = v2();
    var radian = 0;
    var numInsert = 0;
    var i = pos_game.length - 1;
    p0 = pos_game[i - 2];
    p1 = pos_game[i - 1];
    p2 = pos_game[i];
    Vec2.subtract(pos_offset01, v2(p0.x, p0.y), v2(p1.x, p1.y));
    Vec2.subtract(pos_offset12, v2(p1.x, p1.y), v2(p2.x, p2.y));
    Vec2.subtract(pos_offset02, v2(p0.x, p0.y), v2(p2.x, p2.y));
    radian = pos_offset01.signAngle(pos_offset12);

    if (radian != 0) {
      numInsert = Math.ceil(pos_offset02.length() / step);

      for (var k = 1; k <= numInsert; k++) {
        var t = k / (numInsert + 1);
        var ratio1 = (1 - t) * (1 - t);
        var ratio2 = 2 * t * (1 - t);
        var ratio3 = t * t;
        var pos_insert = v3(ratio1 * p0.x + ratio2 * p1.x + ratio3 * p2.x, ratio1 * p0.y + ratio2 * p1.y + ratio3 * p2.y, 0);

        if (pos_game[i - 1 + k - 1]) {
          pos_game[i - 1 + k - 1] = pos_insert;
        } else {
          pos_game.push(pos_insert);
        }
      }
    }
  }
  /**
   * 使用贝塞尔三次曲线 -- 光滑坐标集合
   * @param pos_game 坐标集合
   * @param step 最小单位（两点之间的单位距离）
   * @returns 填充后的数组
   */
  ;

  _proto4.bezierPos_three = function bezierPos_three(pos_game, step) {
    if (pos_game.length < 8) return;
    var p0 = v3();
    var p1 = v3();
    var p2 = v3();
    var p3 = v3(); //根据角度差，判定是否添加新的点， 根据线段长度，确定新增加点的个数

    var pos_offset01 = v2();
    var pos_offset12 = v2();
    var pos_offset23 = v2();
    var pos_offset03 = v2();
    var numInsert = 0;
    var i = pos_game.length - 1;
    p0 = pos_game[i - 3];
    p1 = pos_game[i - 2];
    p2 = pos_game[i - 1];
    p3 = pos_game[i];
    Vec2.subtract(pos_offset01, v2(p0.x, p0.y), v2(p1.x, p1.y));
    Vec2.subtract(pos_offset12, v2(p1.x, p1.y), v2(p2.x, p2.y));
    Vec2.subtract(pos_offset23, v2(p2.x, p2.y), v2(p3.x, p3.y));
    Vec2.subtract(pos_offset03, v2(p0.x, p0.y), v2(p3.x, p3.y));
    var radianP0123 = pos_offset01.signAngle(pos_offset12);
    var radianP123 = pos_offset23.signAngle(pos_offset12);

    if (radianP0123 != 0 || radianP123 != 0) {
      numInsert = Math.ceil(pos_offset03.length() / step);

      for (var k = 1; k <= numInsert; k++) {
        var t = k / (numInsert + 1); //坐标系数

        var ratio0 = (1 - t) * (1 - t) * (1 - t);
        var ratio1 = (1 - t) * (1 - t) * 3 * t;
        var ratio2 = 3 * t * t * (1 - t);
        var ratio3 = t * t * t;
        var xOffset = ratio0 * p0.x + ratio1 * p1.x + ratio2 * p2.x + ratio3 * p3.x;
        var yOffset = ratio0 * p0.y + ratio1 * p1.y + ratio2 * p2.y + ratio3 * p3.y;
        var pos_insert = v3(xOffset, yOffset, 0); //更新 - 填充坐标

        if (pos_game[i - 2 + k - 1]) {
          pos_game[i - 2 + k - 1] = pos_insert;
        } else {
          pos_game.push(pos_insert);
        }
      }
    }
  }
  /**
   * 测试点是否在矩形区域内
   * @param posCur_w 测试点
   * @param rect_cur 测试矩形
   * @returns 测试结果
   */
  ;

  _proto4.pointInRect = function pointInRect(posCur_w, rect_cur) {
    var rect_point = new Rect(posCur_w.x, posCur_w.y, 0.05, 0.05);
    var rect_out = new Rect(0, 0, 0, 0);
    Rect.intersection(rect_out, rect_point, rect_cur);
    return rect_out;
  }
  /**
   * 获取矩形与线段的交点
   * @param a 线段A - 端点
   * @param b 线段B - 端点
   * @param rect 矩形
   */
  ;

  _proto4.getCrossPoint_lineRect = function getCrossPoint_lineRect(a, b, rect) {
    var pos1 = v2(rect.xMin, rect.yMin);
    var pos2 = v2(rect.xMin, rect.yMax);
    var pos3 = v2(rect.xMax, rect.yMax);
    var pos4 = v2(rect.xMax, rect.yMin);
    var points = [];
    var line1 = [];
    line1.push(pos1);
    line1.push(pos2);
    var line2 = [];
    line2.push(pos2);
    line2.push(pos3);
    var line3 = [];
    line3.push(pos3);
    line3.push(pos4);
    var line4 = [];
    line4.push(pos4);
    line4.push(pos1);
    points.push(line1);
    points.push(line2);
    points.push(line3);
    points.push(line4);

    for (var i = 0; i < 4; i++) {
      // let p: Vec2 = this.getCrossPoint1_lineLine(points[i][0], points[i][1], a, b);
      var p = this.getCrossPoint_lineLine(points[i][0], points[i][1], a, b);

      if (p) {
        return p;
      }
    }

    return null;
  }
  /**
   * 获取两条线段的交点(可以求直线与线段的交点)
   * @param a 线段LineA - 端点
   * @param b 线段LineA - 端点
   * @param c 线段LineB - 端点
   * @param d 线段LineB - 端点
   */
  ;

  _proto4.getCrossPoint1_lineLine = function getCrossPoint1_lineLine(a, b, c, d) {
    //如果分母为0， 则平行或共线，不相交
    var isParallel = (b.y - a.y) * (d.x - c.x) - (a.x - b.x) * (c.y - d.y);

    if (isParallel === 0) {
      return null;
    } //线段所在直线的交点（x,y）


    var x = ((b.x - a.x) * (d.x - c.x) * (c.y - a.y) + (b.y - a.y) * (d.x - c.x) * a.x - (d.y - c.y) * (b.x - a.x) * c.x) / isParallel;
    var y = -((b.y - a.y) * (d.y - c.y) * (c.x - a.x) + (b.x - a.x) * (d.y - c.y) * a.y - (d.x - c.x) * (b.y - a.y) * c.y) / isParallel; //判定点在两条线段上

    if ((x - a.x) * (x - b.x) <= 0 && (y - a.y) * (y - b.y) <= 0 && (x - c.x) * (x - d.x) <= 0 && (y - c.y) * (y - d.y) <= 0) {
      return v2(x, y);
    }

    return null;
  }
  /**
   * 获取两条线段的交点
   * @param p1 线段LineA - 端点
   * @param p2 线段LineA - 端点
   * @param p3 线段LineB - 端点
   * @param p4 线段LineB - 端点
   */
  ;

  _proto4.getCrossPoint_lineLine = function getCrossPoint_lineLine(p1, p2, p3, p4) {
    var k = Math.abs(this.getAreaByVector(p1, p2, p3)) / Math.abs(this.getAreaByVector(p1, p2, p4));
    return v2((p3.x + k * p4.x) / (1 + k), (p3.y + k * p4.y) / (1 + k));
  }
  /**
   * 向量法，求三角形面积
   * @param p1 向量A,B的公共顶点
   * @param p2 向量A 的端点
   * @param p3 向量B 的端点
   */
  ;

  _proto4.getAreaByVector = function getAreaByVector(p1, p2, p3) {
    return (p2.x - p1.x) * (p3.y - p1.y) - (p2.y - p1.y) * (p3.x - p1.x);
  }
  /**获取矩形与矩形的交点 */
  ;

  _proto4.getInsertPointBetweenNodeAndNode = function getInsertPointBetweenNodeAndNode(n_1, n_2) {
    var posArr = [];
    var posArr_1 = this.getAimRect(n_1);
    var posArr_2 = this.getAimRect(n_2);

    for (var i = 0; i < posArr_1.length; i++) {
      var p1 = posArr_1[i];
      var p2 = i == 3 ? posArr_1[0] : posArr_1[i + 1];

      for (var j = 0; j < posArr_2.length; j++) {
        var p3 = posArr_2[j];
        var p4 = j == 3 ? posArr_2[0] : posArr_2[j + 1];
        var p = this.getCrossPoint_lineLine(p1, p2, p3, p4);

        if (p) {
          posArr.push(p);
        }
      }
    }

    return posArr;
  };

  _proto4.getAimRect = function getAimRect(n_rect) {
    var rect = new Rect();
    var uiTransform = n_rect.getComponent(UITransform);
    rect.width = uiTransform.contentSize.width * n_rect.scale.x * n_rect.parent.scale.x;
    rect.height = uiTransform.contentSize.height * n_rect.scale.y * n_rect.parent.scale.y;
    rect.x = -uiTransform.anchorX * rect.width;
    rect.y = -uiTransform.anchorY * rect.height;
    var posArr = [];
    posArr.push(v2(rect.xMin, rect.yMin));
    posArr.push(v2(rect.xMin, rect.yMax));
    posArr.push(v2(rect.xMax, rect.yMax));
    posArr.push(v2(rect.xMax, rect.yMin));
    var radians = misc.degreesToRadians(n_rect.angle);

    for (var i = 0; i < posArr.length; i++) {
      posArr[i].rotate(radians);
      posArr[i].add(v2(n_rect.worldPosition.x, n_rect.worldPosition.y));
    }

    return posArr;
  }
  /**获取圆与矩形的交点 */
  ;

  _proto4.getInsertPointBetweenCircleAndNode = function getInsertPointBetweenCircleAndNode(n_rect, n_circle, r) {
    var rect = new Rect();
    var uiTransform = n_rect.getComponent(UITransform);
    rect.width = uiTransform.contentSize.width * n_rect.scale.x * n_rect.parent.scale.x;
    rect.height = uiTransform.contentSize.height * n_rect.scale.y * n_rect.parent.scale.y;
    rect.x = -uiTransform.anchorX * rect.width;
    rect.y = -uiTransform.anchorY * rect.height;
    var posArr = [];
    posArr.push(v2(rect.xMin, rect.yMin));
    posArr.push(v2(rect.xMin, rect.yMax));
    posArr.push(v2(rect.xMax, rect.yMax));
    posArr.push(v2(rect.xMax, rect.yMin));
    var radians = misc.degreesToRadians(n_rect.angle);

    for (var i = 0; i < posArr.length; i++) {
      posArr[i].rotate(radians);
      posArr[i].add(v2(n_rect.worldPosition.x, n_rect.worldPosition.y));
    }

    var m = n_circle.worldPosition.x;
    var n = n_circle.worldPosition.y;
    var posContact = [];

    for (var j = 0; j < 4; j++) {
      var posCur = posArr[j];
      var posNext = v2();

      if (j == 3) {
        posNext = posArr[0];
      } else {
        posNext = posArr[j + 1]; //841
      }

      var tempPosArr = this.getInsertPointBetweenCircleAndLine(posCur.x, posCur.y, posNext.x, posNext.y, m, n, r);

      if (tempPosArr.length > 0) {
        posContact.push.apply(posContact, tempPosArr);
      }
    }

    return posContact;
  }
  /**
   * 求直线与圆的交点
   * @param x1 点a.x
   * @param y1 点a.y
   * @param x2 点b.x
   * @param y2 点b.y
   * @param m 圆center.x
   * @param n 圆center.y
   * @param r 圆 radians
   * @returns arr： vec2[] 交点数组
   */
  ;

  _proto4.getInsertPointBetweenCircleAndLine = function getInsertPointBetweenCircleAndLine(x1, y1, x2, y2, m, n, r) {
    var posArr = [];
    var k = 0;
    var b = 0;

    if (x1 != x2) {
      var kbArr = this.binaryEquationGetKB(x1, y1, x2, y2);
      k = kbArr[0];
      b = kbArr[1];
    } else {
      if (Math.abs(x1 - m) > r) {
        return posArr;
      } else if (Math.abs(x1 - m) == r) {
        posArr.push(v2(x1, (y1 + y2) / 2));
      } else {
        var y = Math.sqrt(r * r - (x1 - m) * (x1 - m));
        var y_min = y1;
        var y_max = y2;

        if (y1 > y2) {
          y_min = y2;
          y_max = y1;
        }

        if (y + n > y_min && y + n < y_max) {
          posArr.push(v2(x1, y + n));
        }

        if (-y + n > y_min && -y + n < y_max) {
          posArr.push(v2(x1, -y + n));
        }
      }

      return posArr;
    } //点到直线大于半径


    var d = (k * m - n + b) / Math.sqrt(k * k + 1);
    if (Math.abs(d) > r) return posArr; //求交点

    var aX = 1 + k * k;
    var bX = 2 * k * (b - n) - 2 * m;
    var cX = m * m + (b - n) * (b - n) - r * r;
    /**
     * y = kx + b
     * ax2 + bx + c = 0;
     * (x - m)2 + (y - n)2 = r2
     * x2 - 2mx + m2 + y2 - 2ny + n2 = r2
     * x2 - 2mx + y2 - 2ny = r2 - m2 - n2;
     * x2 - 2mx + (kx + b)2 - 2n(kx + b) = r2 - m2 - n2
     * x2 - 2mx + k2x2 + 2kbx + b2 - 2nkx - 2nb = r2 - m2 - n2 - b2
     * (1 + k2)x2 + (-2m + 2kb - 2nk)x = r2 - m2 - n2 + 2nb - b2
     */

    var x_min = 0;
    var x_max = 0;

    if (x1 < x2) {
      x_min = x1;
      x_max = x2;
    } else {
      x_min = x2;
      x_max = x1;
    }

    var xArr = this.quadEquationGetX(aX, bX, cX);
    xArr.forEach(function (x) {
      if (x >= x_min && x <= x_max) {
        var _y = k * x + b;

        posArr.push(v2(x, _y));
      }
    });
    return posArr;
  }
  /**
   * 根据两点，求直线方程系数 y = kx + b;
   * @param x1 点a.x
   * @param y1 点a.y
   * @param x2 点b.x
   * @param y2 点b.y
   * @returns k,b
   */
  ;

  _proto4.binaryEquationGetKB = function binaryEquationGetKB(x1, y1, x2, y2) {
    var k = (y1 - y2) / (x1 - x2);
    var b = (x1 * y2 - x2 * y1) / (x1 - x2);
    var arr = [];
    arr.push(k);
    arr.push(b);
    return arr;
  }
  /**一元二次方程求系数  ax2 + bx + c = 0 */
  ;

  _proto4.quadEquationGetX = function quadEquationGetX(a, b, c) {
    var xArr = [];
    var result = Math.pow(b, 2) - 4 * a * c;

    if (result > 0) {
      xArr.push((-b + Math.sqrt(result)) / (2 * a));
      xArr.push((-b - Math.sqrt(result)) / (2 * a));
    } else if (result == 0) {
      xArr.push(-b / (2 * a));
    }

    return xArr;
  };

  return PosHandler;
}();

_cclegacy._RF.pop();